<template>
    <v-select id="country-droplist" style="border:none;" v-model="selectedCountry" label="name" placeholder="Country" :options="countries" />
</template>

<script>
import vSelect from 'vue-select'
export default {
  components: {
    vSelect
  },
  data: () => ({
    selectedCountry: null
  }),
  computed: {
    countries () {
      return this.$store.getters['SHIPPING/COUNTRIES']
    }
  },
  watch: {
    selectedCountry () {
      if((this.selectedCountry.shippingZoneId) === null) return;
      this.$store.dispatch('SHIPPING/GET_SHIPPING', this.selectedCountry.shippingZoneId)
      this.$emit('countryChanged', this.selectedCountry.name)
      this.$store.dispatch("CHECKOUT/UPDATE_CHECKOUT_MODEL_FIELD", { property: 'shippingZoneId', value: this.selectedCountry.shippingZoneId })
    }
  }
}
</script>

<style lang="postcss">
.clear {display: none;} /* removing "clear" selected value option from select list */
.dropdown-toggle { 
    border: none !important; 
    width: 100%; 
  }
  .dropdown-toggle,
  #country-droplist input[type=search], 
  #country-droplist,  input[type=search]:focus {
    border: none;
  }
  #country-droplist{
    border: 1px solid #777 !important;
    padding: 5px;
    width: 100%;
}

@media screen and (max-width: 768px) {
  .dropdown-toggle { 
    height: 38px;
  }
}

</style>
